(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["orska-customer-fields-app"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.orskaCustomerFieldsAppScoped) return;
    window.orskaCustomerFieldsAppScoped = true;

    const scopeSelector = '.cf-form-block';
    const scopedAttr = 'orskaCfScoped';

    const splitSelectors = (selectors) => {
      const parts = [];
      let part = '';
      let depth = 0;
      let quote = '';
      let escaped = false;

      for (const char of selectors) {
        if (escaped) {
          part += char;
          escaped = false;
          continue;
        }

        if (char === '\\') {
          part += char;
          escaped = true;
          continue;
        }

        if (quote) {
          part += char;
          if (char === quote) quote = '';
          continue;
        }

        if (char === '"' || char === "'") {
          part += char;
          quote = char;
          continue;
        }

        if (char === '(' || char === '[') depth += 1;
        if (char === ')' || char === ']') depth = Math.max(0, depth - 1);

        if (char === ',' && depth === 0) {
          parts.push(part.trim());
          part = '';
          continue;
        }

        part += char;
      }

      if (part.trim()) parts.push(part.trim());
      return parts;
    };

    const scopeSelectors = (selectors) =>
      splitSelectors(selectors)
        .map((selector) => {
          if (!selector || selector.startsWith(scopeSelector)) return selector;
          return `${scopeSelector} ${selector}`;
        })
        .join(', ');

    const scopeCss = (css) => {
      const source = css.replace(/\/\*[\s\S]*?\*\//g, '');
      let output = '';
      let selector = '';
      let body = '';
      let depth = 0;

      for (const char of source) {
        if (char === '{') {
          if (depth === 0) {
            selector = body.trim();
            body = '';
          } else {
            body += char;
          }
          depth += 1;
          continue;
        }

        if (char === '}') {
          depth -= 1;
          if (depth === 0) {
            const ruleBody = body.trim();
            const trimmedSelector = selector.trim();

            if (trimmedSelector.startsWith('@media') || trimmedSelector.startsWith('@supports') || trimmedSelector.startsWith('@container') || trimmedSelector.startsWith('@layer')) {
              output += `${trimmedSelector}{${scopeCss(ruleBody)}}`;
            } else if (trimmedSelector.startsWith('@')) {
              output += `${trimmedSelector}{${ruleBody}}`;
            } else if (trimmedSelector) {
              output += `${scopeSelectors(trimmedSelector)}{${ruleBody}}`;
            }

            selector = '';
            body = '';
            continue;
          }
        }

        body += char;
      }

      return output;
    };

    const scopeStyle = (style) => {
      if (style.dataset[scopedAttr] === 'true' && style.textContent.includes(scopeSelector)) return;
      const scopedCss = scopeCss(style.textContent || '');
      if (!scopedCss) return;
      style.textContent = scopedCss;
      style.dataset[scopedAttr] = 'true';
    };

    const scopeFormStyles = () => {
      const sections = document.querySelectorAll('[data-orska-cf-form-section]');
      if (!sections.length) return;

      sections.forEach((section) => {
        const formId = section.getAttribute('data-cf-form-id');
        if (!formId) return;

        document.querySelectorAll('style[data-cf-form-id]').forEach((style) => {
          if (style.getAttribute('data-cf-form-id') === formId) scopeStyle(style);
        });
      });
    };

    const autocompleteRules = [
      { pattern: /email|e-mail/, value: 'email' },
      { pattern: /phone|tel|mobile/, value: 'tel' },
      { pattern: /first[_\s.-]*name|given[_\s.-]*name/, value: 'given-name' },
      { pattern: /last[_\s.-]*name|family[_\s.-]*name|surname/, value: 'family-name' },
      { pattern: /full[_\s.-]*name|customer\.name|(^|\s)name($|\s)/, value: 'name' },
      { pattern: /company|organization|business/, value: 'organization' },
      { pattern: /address[_\s.-]*(1|line[_\s.-]*1)|address1/, value: 'address-line1' },
      { pattern: /address[_\s.-]*(2|line[_\s.-]*2)|address2/, value: 'address-line2' },
      { pattern: /city/, value: 'address-level2' },
      { pattern: /province|state|region/, value: 'address-level1' },
      { pattern: /zip|postal/, value: 'postal-code' },
      { pattern: /country/, value: 'country-name' },
    ];

    const fieldLabelText = (field) => {
      const labelId = field.getAttribute('aria-labelledby');
      const labelledBy = labelId ? document.getElementById(labelId)?.textContent : '';
      const explicitLabel = field.id ? [...document.querySelectorAll('label')].find((label) => label.htmlFor === field.id)?.textContent : '';
      const wrapperLabel = field.closest('.cf-field')?.querySelector('label')?.textContent;

      return [labelledBy, explicitLabel, wrapperLabel].filter(Boolean).join(' ');
    };

    const autocompleteKey = (field) =>
      [
        field.getAttribute('data-cf-column-key'),
        field.getAttribute('name'),
        field.getAttribute('id'),
        field.getAttribute('placeholder'),
        fieldLabelText(field),
      ]
        .filter(Boolean)
        .join(' ')
        .toLowerCase();

    const applyFieldAutocomplete = () => {
      document.querySelectorAll('[data-orska-cf-form-section]').forEach((section) => {
        section.querySelectorAll('input, select, textarea').forEach((field) => {
          if (!(field instanceof HTMLInputElement || field instanceof HTMLSelectElement || field instanceof HTMLTextAreaElement)) return;
          if (field.matches('input[type="hidden"], input[type="password"], input[type="search"]')) return;
          if ((field.getAttribute('autocomplete') || '').trim()) return;

          const key = autocompleteKey(field);
          const match = autocompleteRules.find((rule) => rule.pattern.test(key));

          if (match) field.setAttribute('autocomplete', match.value);
        });
      });
    };

    const enhanceForms = () => {
      scopeFormStyles();
      applyFieldAutocomplete();
    };

    let queued = false;
    const queueScope = () => {
      if (queued) return;
      queued = true;
      requestAnimationFrame(() => {
        queued = false;
        enhanceForms();
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', enhanceForms, { once: true });
    } else {
      enhanceForms();
    }

    document.addEventListener('shopify:section:load', enhanceForms);
    new MutationObserver(queueScope).observe(document.documentElement, { childList: true, subtree: true });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["orska-faq"] && !Shopify.designMode) return;
  try {
    
  if (!window.orskaFaqAccordionBound) {
    window.orskaFaqAccordionBound = true;

    const prefersReducedMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const finishAnimation = (item, answer, shouldStayOpen) => {
      item.classList.remove('is-opening', 'is-closing', 'is-animating');
      answer.style.height = '';

      if (!shouldStayOpen) {
        item.removeAttribute('open');
      }
    };

    const openItem = (item, answer) => {
      item.setAttribute('open', '');
      item.classList.add('is-opening', 'is-animating');
      answer.style.height = '0px';

      requestAnimationFrame(() => {
        answer.style.height = `${answer.scrollHeight}px`;
      });

      const onTransitionEnd = (event) => {
        if (event.propertyName !== 'height') return;

        answer.removeEventListener('transitionend', onTransitionEnd);
        finishAnimation(item, answer, true);
      };

      answer.addEventListener('transitionend', onTransitionEnd);
    };

    const closeItem = (item, answer) => {
      item.classList.add('is-closing', 'is-animating');
      answer.style.height = `${answer.scrollHeight}px`;

      requestAnimationFrame(() => {
        answer.style.height = '0px';
      });

      const onTransitionEnd = (event) => {
        if (event.propertyName !== 'height') return;

        answer.removeEventListener('transitionend', onTransitionEnd);
        finishAnimation(item, answer, false);
      };

      answer.addEventListener('transitionend', onTransitionEnd);
    };

    document.addEventListener('click', (event) => {
      const summary = event.target.closest('.orska-faq-item__question');

      if (!summary) return;

      const item = summary.closest('.orska-faq-item');
      const answer = item?.querySelector('.orska-faq-item__answer');

      if (!item || !answer) return;

      event.preventDefault();

      if (item.classList.contains('is-animating')) return;

      if (prefersReducedMotion()) {
        item.open = !item.open;
        return;
      }

      if (item.open) {
        closeItem(item, answer);
      } else {
        openItem(item, answer);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["orska-lineup-nav"] && !Shopify.designMode) return;
  try {
    
  if (!window.orskaLineupNavBound) {
    window.orskaLineupNavBound = true;

    const initNav = (nav) => {
      const pills = Array.from(nav.querySelectorAll('.orska-lineup-pill'));
      if (!pills.length) return;

      const wrap = nav.closest('.orska-lineup-nav-wrap') || nav;
      let pairs = [];
      const refresh = () => {
        pairs = pills
          .map((pill) => ({ pill, el: document.getElementById(pill.getAttribute('data-orska-lineup-target')) }))
          .filter((pair) => pair.el);
      };
      refresh();
      if (!pairs.length) return;

      let ticking = false;
      let lastActive = null;
      const centerPill = (pill) => {
        if (nav.scrollWidth <= nav.clientWidth + 1) return;
        const navRect = nav.getBoundingClientRect();
        const pillRect = pill.getBoundingClientRect();
        const delta = (pillRect.left - navRect.left) - (nav.clientWidth - pillRect.width) / 2;
        const max = nav.scrollWidth - nav.clientWidth;
        const target = Math.max(0, Math.min(nav.scrollLeft + delta, max));
        nav.scrollTo({ left: target, behavior: 'smooth' });
      };
      const update = () => {
        ticking = false;
        if (!pairs.length) return;
        const line = wrap.getBoundingClientRect().bottom + 12;
        let active = pairs[0];
        pairs.forEach((pair) => {
          if (pair.el.getBoundingClientRect().top <= line) active = pair;
        });
        pills.forEach((pill) => pill.classList.toggle('is-active', pill === active.pill));
        if (active.pill !== lastActive) {
          lastActive = active.pill;
          centerPill(active.pill);
        }
      };
      pills.forEach((pill) => {
        pill.addEventListener('click', () => {
          pills.forEach((other) => other.classList.toggle('is-active', other === pill));
          lastActive = pill;
          centerPill(pill);
        });
      });
      const onScroll = () => {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(update);
      };

      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', () => {
        refresh();
        onScroll();
      });
      update();
    };

    const boot = () => document.querySelectorAll('.orska-lineup-nav').forEach(initNav);

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }

    document.addEventListener('shopify:section:load', (event) => {
      const nav = event.target.querySelector('.orska-lineup-nav');
      if (nav) initNav(nav);
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["orska-media-feature"] && !Shopify.designMode) return;
  try {
    
  if (!window.orskaMediaFeatureModalFit) {
    window.orskaMediaFeatureModalFit = true;

    document.addEventListener('loadedmetadata', (event) => {
      const video = event.target;
      if (!(video instanceof HTMLVideoElement)) return;

      const dialog = video.closest('.orska-video-modal__dialog');
      const modal = video.closest('dialog-component[id^="orska-media-feature-modal-"]');
      if (!dialog || !modal || !video.videoWidth || !video.videoHeight) return;

      dialog.style.setProperty('--orska-modal-aspect', video.videoWidth + ' / ' + video.videoHeight);
      dialog.style.setProperty('--orska-modal-ar', (video.videoWidth / video.videoHeight).toFixed(4));
    }, true);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["orska-professional-choice"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var STORAGE_KEY = 'orska_pro_confirmed';
    var root = document.querySelector('[data-signin-gate-root]');
    if (!root) return;
    var gate = root.querySelector('#orska-signin-gate');
    var signinBtn = root.querySelector('[data-signin-gate]');
    if (!gate || !signinBtn) return;

    var applyHref = root.getAttribute('data-apply-href') || '/pages/for-professionals#apply';
    var pendingHref = null;

    function isRemembered() {
      try { return localStorage.getItem(STORAGE_KEY) === '1'; }
      catch (e) { return false; }
    }
    function remember() {
      try { localStorage.setItem(STORAGE_KEY, '1'); } catch (e) {}
    }
    function openGate() { gate.hidden = false; document.body.style.overflow = 'hidden'; }
    function closeGate() { gate.hidden = true; document.body.style.overflow = ''; pendingHref = null; }

    signinBtn.addEventListener('click', function (e) {
      if (signinBtn.hasAttribute('data-signin-gate-skip')) return;
      if (isRemembered()) return;
      e.preventDefault();
      pendingHref = signinBtn.getAttribute('href');
      openGate();
    });

    gate.addEventListener('click', function (e) {
      if (e.target === gate) closeGate();
    });

    var closeBtn = gate.querySelector('[data-signin-gate-close]');
    if (closeBtn) closeBtn.addEventListener('click', closeGate);

    var confirmBtn = gate.querySelector('[data-signin-gate-confirm]');
    if (confirmBtn) confirmBtn.addEventListener('click', function () {
      remember();
      window.location.href = pendingHref || signinBtn.getAttribute('href');
    });

    var applyBtn = gate.querySelector('[data-signin-gate-apply]');
    if (applyBtn) applyBtn.addEventListener('click', function () {
      window.location.href = applyHref;
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !gate.hidden) closeGate();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
